import { render, staticRenderFns } from "./SpotQuestions.vue?vue&type=template&id=bbabd47e&"
import script from "./SpotQuestions.vue?vue&type=script&lang=js&"
export * from "./SpotQuestions.vue?vue&type=script&lang=js&"
import style0 from "./SpotQuestions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports